import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Discover } from './pages/Discover';
import { FlyWithUs } from './pages/FlyWithUs';
import { OwnerServices } from './pages/OwnerServices';
import { Training } from './pages/Training';
import { Brokerage } from './pages/Brokerage';
import { EmptyLegs } from './pages/EmptyLegs';
import { Contact } from './pages/Contact';
export function App() {
  return <Router data-id="element-0">
      <div className="min-h-screen bg-white font-sans text-charcoal-900 selection:bg-brand-200 selection:text-brand-900 flex flex-col" data-id="element-1">
        <Navbar data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/discover" element={<Discover data-id="element-8" />} data-id="element-7" />
            <Route path="/fly-with-us" element={<FlyWithUs data-id="element-10" />} data-id="element-9" />
            <Route path="/owner-services" element={<OwnerServices data-id="element-12" />} data-id="element-11" />
            <Route path="/training" element={<Training data-id="element-14" />} data-id="element-13" />
            <Route path="/brokerage" element={<Brokerage data-id="element-16" />} data-id="element-15" />
            <Route path="/empty-legs" element={<EmptyLegs data-id="element-18" />} data-id="element-17" />
            <Route path="/contact" element={<Contact data-id="element-20" />} data-id="element-19" />
          </Routes>
        </main>
        <Footer data-id="element-21" />
      </div>
    </Router>;
}